module.exports = __webpack_public_path__ + "img/3_1.a4e3cb3c.png";